export default "__VITE_ASSET__b8e2afdc__"